import { render } from "./TickIcon.svg?vue&type=template&id=96b149ec"
const script = {}
script.render = render

export default script